interface Props {
  color?: string,
}

const Check = ({ color = '#10B981' }: Props): JSX.Element => {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z" 
        fill={color} 
      />
    </svg>
  );
}

export default Check;